// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__2ORwB","addWidgetButton":"Header_addWidgetButton__3aATO","dashboardTabs":"Header_dashboardTabs__34nRv","active":"Header_active__1aKRl"};